import React, { useMemo, useState } from "react";
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import EmployeeListAdmin from "../../pages/Admin/EmployeeListAdmin";
import { GlobalContext } from "../../Context/GlobalState";
import GlobalLoader from "../../components/GlobalLoader";

ChartJS.register(ArcElement, Tooltip, Legend);

const EmployeeListAdminWidget = ({ firmId, user }) => {
  const [transactionLoader, setTransactionLoaderState] = useState(false);

  const widgetUser = useMemo(
    () => ({
      us_type: "A",
      ...(user || {}),
      firm_id: user?.firm_id || user?.firmId || firmId,
    }),
    [firmId, user]
  );

  const contextValue = useMemo(
    () => ({
      Profileinfo: null,
      token: null,
      user: widgetUser,
      userparent: null,
      transactionLoader,
      accessData: [],
      accessDataemp: null,
      setTransactionLoaderState,
      setToken: () => {},
      setProfileinfo: () => {},
      setMyAccountInfo: () => {},
      setUserInfo: () => {},
      setUserParent: () => {},
      setAccessData: () => {},
      setAccessemployeData: () => {},
    }),
    [transactionLoader, widgetUser]
  );

  return (
    <GlobalContext.Provider value={contextValue}>
      <GlobalLoader />
      <EmployeeListAdmin />
    </GlobalContext.Provider>
  );
};

export default EmployeeListAdminWidget;
